import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import App from './App.vue'
import ElLoading from 'element-loading'

// Generic dependencies
import { get } from 'lodash'
import * as log from 'loglevel'

log.setLevel('info')
log.info('main.js', Vue)
Object.defineProperty(Vue.prototype, '$log', { value: log })

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
// configure language
locale.use(lang)

// Vue.use(ElementUI, {locale})

// Dependencies for http://element.eleme.io/
import {
  Badge,
  Button,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Input,
  InputNumber,
  Loading,
  Message,
  MessageBox,
  Option,
  Popover,
  Radio,
  RadioButton,
  RadioGroup,
  Select,
  Slider,
  Step,
  Steps,
  Switch,
  TabPane,
  Tabs,
  Tag,
  Tooltip
} from 'element-ui'

Vue.use(Badge)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Option)
Vue.use(Popover)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Select)
Vue.use(Slider)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Switch)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Tooltip)

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
// Notification does not exist in some browsers(e.g. mobile brosers)
if (Notification) {
  Vue.prototype.$notify = Notification
}
Vue.prototype.$message = Message

Vue.use(ElLoading)

// Dependencies for highcharts
import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import loadMore from 'highcharts/highcharts-more'

loadMore(Highcharts)
Vue.use(VueHighcharts, { Highcharts })

// Dependencies for top-progress
import vueTopprogress from 'vue-top-progress'

Vue.use(vueTopprogress)

// Vue router set-up
import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store'
sync(store, router)

Vue.use(VueAnalytics, {
  id: 'UA-115351934-1',
  checkDuplicatedScript: true,
  router
})

// Axios intercepts for Unauthorized access (401) and Maintenance (503)
import axios from 'axios'

function promptRedirect() {
  try {
    MessageBox.alert(
      'You probably need to re-login or you are not authorised to use SWARM on this problem. Please contact administrators for further explanation',
      'Failed authentication or authorization',
      {
        confirmButtonText: 'OK',
        callback: action => {
          let url = store.state.platform['T&E Portal URL']
          if (url) {
            window.location.href = url
          }
        }
      }
    )
  } catch (e) {
    // pass
  }
}

axios.interceptors.response.use(
  response => {
    return response
  },
  function(error) {
    let authProvider
    try {
      authProvider = store.getters.authProvider
      log.info('Interceptors - 401 - authProvider', authProvider)
    } catch (e) {
      // pass
    }
    // TO DO:
    // Differentiate between error invoked from ajax calls or router changes
    // (between action to add/change content or navigational change)
    let errorCode = get(error, 'response.status', -1)
    if (errorCode === 401 && error.config && !error.config.__isRetryRequest) {
      log.info('Interceptors - 401', router, router.history.current.fullPath)
      error.config.__isRetryRequest = true
      return store
        .dispatch('getNewAccessToken')
        .then(function(newAccessToken) {
          error.config.headers.Authorization = newAccessToken
          return axios.request(error.config)
        })
        .catch(function(err) {
          log.info('Interceptors - 401 error', err)
          store
            .dispatch('logout')
            .then(function() {
              if (authProvider !== 'tne') {
                router.push('/login')
              } else {
                promptRedirect()
              }
            })
            .catch(function() {
              if (authProvider !== 'tne') {
                router.push('/login')
              } else {
                promptRedirect()
              }
            })
        })
    } else if (errorCode === 503) {
      router.push('/maintenance')
    }
    return Promise.reject(error)
  }
)

Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  ...App
})

export { app, router, store }
